import { useDecision } from '@optimizely/react-sdk'

import { EXPERIMENT_KEY_FEATURED_RANGE_MERCHANDISING } from 'routes/Menu/constants/experiments'

export const useIsFeaturedRangeMerchandisingEnabled = () => {
  const [featureFlagDecision] = useDecision(EXPERIMENT_KEY_FEATURED_RANGE_MERCHANDISING)

  return featureFlagDecision.variationKey === 't1'
}
